import { isChrome, isFirefox, isMetaBrowser, isMobileSafari, isSamsungBrowser, isWindowsApp, } from '#pplx/frontend/user-agent-parser/browser.js';
import { isMobile } from '#pplx/frontend/user-agent-parser/device.js';
import { isAndroid, isIOS, isIPad, isLinuxOS, isMacOS, isWindowsOS, } from '#pplx/frontend/user-agent-parser/os.js';
export function getDevice(userAgent = '') {
    if (!userAgent && typeof navigator !== 'undefined') {
        userAgent = navigator.userAgent;
    }
    return {
        isChrome: isChrome(userAgent),
        isMobile: isMobile(userAgent),
        isAndroid: isAndroid(userAgent),
        isIOS: isIOS(userAgent),
        isIPad: isIPad(userAgent),
        isMacOS: isMacOS(userAgent),
        isMobileSafari: isMobileSafari(userAgent),
        isFirefox: isFirefox(userAgent),
        isWindowsApp: isWindowsApp(userAgent),
        isWindowsOS: isWindowsOS(userAgent),
        isLinuxOS: isLinuxOS(userAgent),
        isMetaBrowser: isMetaBrowser(userAgent),
        isSamsungBrowser: isSamsungBrowser(userAgent),
        userAgent,
    };
}
//# sourceMappingURL=device.js.map